



















































































import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import RidesTable from '@/components/Employees/RidesTable.vue';
import CreditTable from '@/components/Employees/CreditTable.vue';
import PaymentsTable from '@/components/Employees/PaymentsTable.vue';
import TracingTable from '@/components/Employees/TracingTable.vue';
import UserForm from '@/components/Employees/UserForm.vue';
import TicketForm from '@/components/Employees/TicketForm.vue';
import CreditForm from '@/components/Employees/CreditForm.vue';

export default Vue.extend({
    components: {
        RidesTable,
        TracingTable,
        CreditTable,
        PaymentsTable,
        UserForm,
        TicketForm,
        CreditForm,
    },
    data() {
        return {
            dates: [] as Array<string>,
            creditData: [],
            creditBalance: 0,
            tab: null,
            employeeObject: {},
            userFormOpen: false,
            ticketFormOpen: false,
            creditFormOpen: false,
            ticketBtn: true,
            creditBtn: false,
            paymentEnabled: false,
        };
    },
    methods: {
        ...mapActions('tickets', ['getTickets']),

        async handleBtns(btnName: string) {
            this.ticketBtn = (btnName === 'ticketBtn');
            this.creditBtn = (btnName === 'creditBtn');
        },
        onSave() {
            this.getTickets({ userId: parseInt(this.$route.params.id), dateRange: this.dates });
        },
        async onAddCredit() {
            const userId = parseInt(this.$route.params.id);
            this.creditData = await this.$hipApi.getCreditTransaction(userId, this.dates[0] as string, this.dates[1] as string);
            this.creditBalance = (await this.$hipApi.getCreditBalance(userId))?.balanceUsd || 0;

        },
    },
    watch: {
        dates() {
            this.onAddCredit();
        },
    },
    computed: {
        ...mapState('employees', ['employees']),
        ...mapState('texts', ['employeesDetails']),
        ...mapState('offices', ['corp']),
        employeeName(): string {
            const employee = this.employees.find((employee: any) => employee.userId === parseInt(this.$route.params.id));
            Object.assign(this.employeeObject, employee);
            return employee?.fullName;
        },
    },
    async created() {
        this.paymentEnabled = !this.corp.isPaymentDisabled;
        const priorDate = new Date();
        const laterDate = new Date();
        priorDate.setDate(priorDate.getDate() - 7);
        laterDate.setDate(laterDate.getDate() + 7);
        this.dates[0] = priorDate.toISOString().substr(0, 10);
        this.dates[1] = laterDate.toISOString().substr(0, 10);
        const userId = parseInt(this.$route.params.id);
        if (userId > 0) {
            this.creditData = await this.$hipApi.getCreditTransaction(userId, this.dates[0] as string, this.dates[1] as string);
            this.creditBalance = (await this.$hipApi.getCreditBalance(userId))?.balanceUsd || 0;
        }
    },
});
